import React, { PureComponent } from "react";

class Navbar extends PureComponent {
  render() {
    return (
      <nav className="navbar navbar-top px-4">
        <div className="col-3 d-flex">
          <a href="https://www.markovic.nz" className="mr-auto">
            markovic.nz
          </a>
        </div>
        <div className="col-6">Pathfinder</div>
        <div className="col-3 d-flex justify-content-end">
          <button
            className="btn rounded-0 p-0 d-flex align-items-center gap-1"
            onClick={this.props.showModalFn}
            style={{ cursor: "pointer" }}
          >
            [info]
          </button>
        </div>
      </nav>
    );
  }
}

export default Navbar;
